import InfoIcon from "@mui/icons-material/InfoOutlined";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  alpha,
} from "@mui/material";
import { Button, Typography } from "@platform/design-system";
import React from "react";

const UnsavedDocs = ({ isOpen, onContinue, onBackDocuments }) => (
  <Dialog fullWidth maxWidth="sm" open={isOpen} onClose={onContinue}>
    <UnsavedDocsBody
      onContinue={onContinue}
      onBackDocuments={onBackDocuments}
    />
  </Dialog>
);

export const UnsavedDocsBody = ({ onContinue, onBackDocuments }) => (
  <>
    <DialogTitle>Unsaved Documents</DialogTitle>
    <DialogContent>
      <Box
        display="flex"
        alignItems="flex-start"
        gap={1}
        bgcolor={alpha("#0288D1", 0.1)}
        p={2}
        borderRadius={4}
      >
        <InfoIcon sx={{ color: "#78a0c0" }} />
        <Typography variant="body-large" component="p">
          <strong>The selected or uploaded Documents are not saved</strong>
          <Typography
            display="block"
            component="span"
            variant="body-large"
            mt={0.5}
          >
            Please go to the next step to Assign Coverages and save documents.
          </Typography>
        </Typography>
      </Box>
    </DialogContent>
    <DialogActions>
      <Button onClick={onContinue} variant="tertiary">
        Continue without saving
      </Button>
      <Button onClick={onBackDocuments} variant="primary">
        Back to Documents
      </Button>
    </DialogActions>
  </>
);

export default UnsavedDocs;
